import React from 'react';
/* Helpers */
import { INTERNAL_THEME } from '../../../helpers/constants';
import { addThousandSeparator, getIfInternalThemeIsBaseSimulator } from '../../../helpers/utils';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setModalThunk } from '../../../redux/actions/index';

export const RequestInfo = ({skipRecap = false}) => {
  const { TAEG } = useSelector(state => state.currentSimulation);
  const internalTheme = useSelector(state => state.internalTheme);
  const dispatch = useDispatch();
  const setModal = (modal, options) => dispatch(setModalThunk(modal, options));

  const getMinMaxStringWithSpan = (min, max, options = {
    label: false,
    symbol: "",
    numberOfDigitsAfterDecimalPoint: 0
  }) => {
    let result = [];

    if (addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint) === addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)) {
      const minMaxString = [<span key="1">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];

      result = [...minMaxString];
    } else {
      let minMaxString = [];

      if (options.label) {
        minMaxString = ['da MIN', <span key="1">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>, ' a MAX ', <span key="2">{`${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];
      } else {
        minMaxString = ['da ', <span key="1">{`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>, ' a ', <span key="2">{`${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`}</span>];
      }

      result = [...minMaxString];
    }
    
    return result;
  }

  const getText = () => {
    switch (internalTheme) {
      case INTERNAL_THEME.COMPASS_ONE_MINUTE_SIMULATOR: {
        return `Per personalizzare la tua richiesta di prestito personale ti chiediamo di fornirci maggiori informazioni.`;
      }
      case INTERNAL_THEME.COMPASS_BASE_SIMULATOR:
      default: {
        return `Per personalizzare la tua richiesta di prestito personale ti chiediamo di fornirci maggiori informazioni. I valori di tan e taeg rimarranno espressi in range finché non avremo preso in carico e valutato la tua richiesta.`
      }
    }
  }

  const getButtonIfEnabled = () => {
    return getIfInternalThemeIsBaseSimulator(internalTheme);
  }

  return (
    <div className="loan-info-scp">
      <div className="loan-info-text-scp">
        {getText()}
      </div>
      <div className="loan-apr-scp">TAEG {getMinMaxStringWithSpan(TAEG.min, TAEG.max, {
        label: false,
        symbol: "%",
        numberOfDigitsAfterDecimalPoint: 2
      })}</div>
      {
        getButtonIfEnabled() 
        &&
        (
          <div className="loan-apr-scp"><button className="loan__info-button" type="button" onClick={function() { setModal('moreInfo', { isVisible: true }) }}>Vuoi saperne di più?</button></div>
        )
      }
    </div>
  );
}
